module.exports = __webpack_public_path__ + "img/shuju@2x.2d6ae7f9.png";